module.exports = __webpack_public_path__ + "01_hair_black.5aedf271.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/01_hair_black.png
// module id = Ds4L
// module chunks = 0